import { render, staticRenderFns } from "./ChatMessage.vue?vue&type=template&id=b6e70314&scoped=true"
import script from "./ChatMessage.vue?vue&type=script&lang=ts"
export * from "./ChatMessage.vue?vue&type=script&lang=ts"
import style0 from "./ChatMessage.vue?vue&type=style&index=0&id=b6e70314&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e70314",
  null
  
)

export default component.exports